import { render, staticRenderFns } from "./SpecificMailFormFields.vue?vue&type=template&id=479f76a8"
import script from "./SpecificMailFormFields.vue?vue&type=script&lang=js"
export * from "./SpecificMailFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports